import { WarningDialog } from '@strata/react-dialog';
import { useFormikContext } from 'formik';
import PropTypes from 'prop-types';

export const PayerMarketMoveSegmentsDialog = ({
    onClose,
    onSubmit,
    segmentsToMove,
    payerMarketsToDelete,
}) => {
    const formik = useFormikContext();
    return (
        <WarningDialog
            dialogTitle="Confirm Move Payer Segment"
            width={560}
            isOpen={segmentsToMove.length > 0}
            secondaryButtonLabel="No, return to Create Payer Market"
            onSecondaryButtonClick={onClose}
            onPrimaryButtonClick={async () => {
                await onSubmit();
                onClose();
            }}
            primaryButtonLabel="Yes, Move Payer Segment"
            dialogContent={
                <div className="padding__bottom--medium">
                    {`Are you sure you want to move ${segmentsToMove.join(', ')} into ${formik.values.payerMarketName}.`}
                    {payerMarketsToDelete.length > 0 &&
                        payerMarketsToDelete.reduce(
                            (prev, curr) =>
                                `${prev} ${curr.removedSegmentNames.join(', ')} ${curr.removedSegmentNames.length > 1 ? 'are' : 'is'} the last remaining ${curr.removedSegmentNames.length > 1 ? 'segments' : 'segment'} within ${curr.payerMarketName}, this action will delete ${curr.payerMarketName}.`,
                            '',
                        )}
                </div>
            }
        />
    );
};

PayerMarketMoveSegmentsDialog.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    segmentsToMove: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
    payerMarketsToDelete: PropTypes.arrayOf(
        PropTypes.shape({
            payerMarketName: PropTypes.string.isRequired,
            removedSegmentNames: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
        }).isRequired,
    ).isRequired,
};
